var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephoneColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.3 426.7c-94.1 0-170.7-76.6-170.7-170.7S119.2 85.3 213.3 85.3 384 161.9 384 256s-76.6 170.7-170.7 170.7z m0-256c-47.1 0-85.3 38.3-85.3 85.3s38.3 85.3 85.3 85.3 85.3-38.3 85.3-85.3-38.2-85.3-85.3-85.3zM768 981.3c-94.1 0-170.7-76.6-170.7-170.7S673.9 640 768 640s170.7 76.6 170.7 170.7S862.1 981.3 768 981.3z m0-256c-47.1 0-85.3 38.3-85.3 85.3 0 47.1 38.3 85.3 85.3 85.3s85.3-38.3 85.3-85.3-38.2-85.3-85.3-85.3z",
    fill: "#3688FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M746.7 981.3c-236 0-656.7-416.9-703.4-697-3.9-23.2 11.8-45.2 35.1-49.1 23.4-3.9 45.2 11.8 49.1 35.1C166.4 504.2 554.1 896 746.7 896c23.6 0 42.7 19.1 42.7 42.7s-19.2 42.6-42.7 42.6z",
    fill: "#3688FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M781.8 543.2c-14.1 0-27.9-7-36.1-19.8-60.1-94.8-141.6-177.3-235.7-238.6-19.7-12.9-25.3-39.3-12.4-59 12.9-19.7 39.3-25.3 59.1-12.4 104.2 67.9 194.5 159.3 261.1 264.4 12.6 19.9 6.7 46.3-13.2 58.9-7.1 4.4-15 6.5-22.8 6.5zM945.2 485.7c-14.7 0-29-7.6-36.9-21.2-81.8-140.8-199-259.2-338.9-342.5-20.2-12.1-26.9-38.2-14.8-58.5 12-20.2 38.2-26.9 58.5-14.8 152.4 90.7 280 219.7 369 372.9 11.8 20.4 4.9 46.5-15.5 58.3-6.7 4-14.1 5.8-21.4 5.8z",
    fill: "#5F6379"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneColor);
export default __webpack_public_path__ + "static/media/telephone_color.4b52076866a694c9167115d989edfcc2.svg";
export { ForwardRef as ReactComponent };